const getEnvLayout = layout => {
  switch (layout) {
    case 'tiendeo':
      return '_TIENDEO'

    case 'promoqui':
      return '_PROMOQUI'

    case 'volantinofacile':
      return '_VOLANTINOFACILE'
    case 'broshura':
      return '_BROSHURA'
    case 'wogibtswas':
      return '_WOGIBTSWAS'
    case 'handelsangebote':
      return '_HANDELSANGEBOTE'
    case 'prospecto':
      return '_PROSPECTO'
    case 'folderscheck':
      return '_FOLDERSCHECK'
    default:
      return ''
  }
}

export default getEnvLayout
